import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetAllDepartments,
} from "../../api/endpoints";
import {baseQueryWithReauth} from "../../api/baseQuery";

export const getDepChangesApi = createApi({
  reducerPath: 'getDepChanges',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllDepartments: builder.query({
      query: () => ({ url: GetAllDepartments, method: 'GET' }),
      skipCache: true
    })
  })
});

export const {
  useGetAllDepartmentsQuery,
} = getDepChangesApi;
